"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtherResidentsChangeDeclineTextOutputWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var OtherResidentsChangeDeclineTextOutputWidget = /** @class */ (function (_super) {
    __extends(OtherResidentsChangeDeclineTextOutputWidget, _super);
    function OtherResidentsChangeDeclineTextOutputWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.underwritingResultArray = _this.props.interaction.underwritingResult;
        _this.declineTextToDisplay = function () {
            var failedRules = _this.underwritingResultArray.map(function (underwritingResult) { return underwritingResult.objectName; });
            var UR005Failed = failedRules.some(function (rule) { return rule.includes("UR005"); });
            var UR006Failed = failedRules.some(function (rule) { return rule.includes("UR006"); });
            var displayMessage = (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
            if (UR005Failed && !UR006Failed) {
                displayMessage = (0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can only insure properties with up to two housemates living there."] }), (0, jsx_runtime_1.jsx)("p", { children: "We will cancel your cover in 7 days time from the date you selected." })] });
            }
            else if (UR006Failed) {
                displayMessage = (0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can only insure properties with up to six adults living there."] }), (0, jsx_runtime_1.jsx)("p", { children: "We will cancel your cover in 7 days time from the date you selected." })] });
            }
            else {
                displayMessage = (0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] }), (0, jsx_runtime_1.jsx)("p", { children: "We will cancel your cover in 7 days time from the date you selected." })] });
            }
            return displayMessage;
        };
        _this.goBack = _this.goBack.bind(_this);
        return _this;
    }
    OtherResidentsChangeDeclineTextOutputWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "text-group declineTextWidget", children: [(0, jsx_runtime_1.jsx)("h1", { children: "Sorry, we can\u2019t insure you" }), (0, jsx_runtime_1.jsx)("div", { className: "panel", children: this.declineTextToDisplay() })] }), (0, jsx_runtime_1.jsx)("button", { type: "button", role: "link", className: "btn btn-back", onClick: this.goBack, id: "decline-page-back", children: "Back" })] }));
    };
    OtherResidentsChangeDeclineTextOutputWidget.prototype.goBack = function () {
        this.props.engine.navigate("startDate", false);
    };
    return OtherResidentsChangeDeclineTextOutputWidget;
}(plugin_journey_1.WidgetBase));
exports.OtherResidentsChangeDeclineTextOutputWidget = OtherResidentsChangeDeclineTextOutputWidget;
//# sourceMappingURL=OtherResidentsChangeDeclineTextOutputWidget.js.map